import React, { useEffect, useState, useContext } from "react";
import "./TechnicalSpecs.css";

import overallImg from "../../../../assets/images/mhero1/technicalSpecs/car1.png";
import storageImg from "../../../../assets/images/mhero1/technicalSpecs/car2.png";
import offroadImg from "../../../../assets/images/mhero1/technicalSpecs/car3.png";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const TechnicalSpecs = () => {
  const { currentLang } = useContext(LanguageContext);

  const [specs, setSpecs] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSpecs = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("mhero1", currentLang);
        setSpecs(response.sections.technical_specs);
      } catch (e) {
        console.error("Failed to load technical specs", e);
      } finally {
        setLoading(false);
      }
    };

    loadSpecs();
  }, [currentLang]);

  if (loading || !specs) return null;

  return (
    <section className="technical-specs">
      {/* TITLE */}
      <h2 className="tech-title">{specs.tech_title}</h2>

      {/* ================= OVERALL ================= */}
      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{specs.badge_overall}</span>

          <ul className="spec-list">
            <li><span className="num">1</span> {specs.overall_1_label} <span className="val">{specs.overall_1_value}</span></li>
            <li><span className="num">2</span> {specs.overall_2_label} <span className="val">{specs.overall_2_value}</span></li>
            <li><span className="num">3</span> {specs.overall_3_label} <span className="val">{specs.overall_3_value}</span></li>
            <li><span className="num">4</span> {specs.overall_4_label} <span className="val">{specs.overall_4_value}</span></li>
            <li><span className="num">5</span> {specs.overall_5_label} <span className="val">{specs.overall_5_value}</span></li>
          </ul>
        </div>

        <div className="spec-right">
          <img className="specImg" src={overallImg} alt="Overall dimensions" />
        </div>
      </div>

      <div className="spec-divider" />

      {/* ================= STORAGE ================= */}
      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{specs.badge_storage}</span>

          <ul className="spec-list">
            <li><span className="num">1</span> {specs.storage_1_label} <span className="val">{specs.storage_1_value}</span></li>
            <li><span className="num">2</span> {specs.storage_2_label} <span className="val">{specs.storage_2_value}</span></li>
          </ul>
        </div>

        <div className="spec-right">
          <img className="specImg" src={storageImg} alt="Storage" />
        </div>
      </div>

      <div className="spec-divider" />

      {/* ================= OFF ROAD ================= */}
      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{specs.badge_offroad}</span>

          <ul className="spec-list">
            <li><span className="num">1</span> {specs.offroad_1_label} <span className="val">{specs.offroad_1_value}</span></li>
            <li><span className="num">2</span> {specs.offroad_2_label} <span className="val">{specs.offroad_2_value}</span></li>
            <li><span className="num">3</span> {specs.offroad_3_label} <span className="val">{specs.offroad_3_value}</span></li>
            <li><span className="num">4</span> {specs.offroad_4_label} <span className="val">{specs.offroad_4_value}</span></li>
            <li><span className="num">5</span> {specs.offroad_5_label} <span className="val">{specs.offroad_5_value}</span></li>
          </ul>
        </div>

        <div className="spec-right">
          <img className="specImg" src={offroadImg} alt="Off-road specs" />
        </div>
      </div>
    </section>
  );
};

export default TechnicalSpecs;
